import { useAccessibleRoute } from '@/libs/hooks/useAccessibleRoute';
import { useAccess, useModel } from '@umijs/max';
import { Result, Spin } from 'antd';
import React, { useEffect, useState } from 'react';

const AccessibleRouteRedirect: React.FC = () => {
  const access: any = useAccess();
  const { initialState } = useModel('@@initialState');
  const { findFirstAccessibleRoute } = useAccessibleRoute();
  const [isChecking, setIsChecking] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const checkAccessAndRedirect = () => {
      // Nếu chưa có user info, chờ
      if (!initialState?.user) {
        return;
      }

      // Nếu là super admin, cho phép truy cập tất cả
      if (initialState.user.role === 'super_admin') {
        setHasAccess(true);
        setIsChecking(false);
        return;
      }

      // Kiểm tra xem user có quyền truy cập route hiện tại không
      const currentPath = window.location.pathname;
      const accessibleRoute = findFirstAccessibleRoute();

      // Nếu không tìm thấy route nào có quyền truy cập
      if (!accessibleRoute) {
        setHasAccess(false);
        setIsChecking(false);
        return;
      }

      // Nếu route hiện tại không phải là route có quyền truy cập đầu tiên
      if (currentPath !== accessibleRoute) {
        // Redirect đến route có quyền truy cập đầu tiên
        window.location.href = accessibleRoute;
        return;
      }

      // Nếu đang ở route có quyền truy cập
      setHasAccess(true);
      setIsChecking(false);
    };

    // Thực hiện kiểm tra sau một khoảng thời gian ngắn để đảm bảo access đã được load
    const timer = setTimeout(checkAccessAndRedirect, 100);
    return () => clearTimeout(timer);
  }, [initialState?.user, access, findFirstAccessibleRoute]);

  // Hiển thị loading khi đang kiểm tra
  if (isChecking) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  // Hiển thị lỗi nếu không có quyền truy cập
  if (!hasAccess) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Xin lỗi, bạn không có quyền truy cập vào hệ thống."
        extra={
          <div>
            <p>Vui lòng liên hệ quản trị viên để được cấp quyền truy cập.</p>
          </div>
        }
      />
    );
  }

  // Hiển thị nội dung nếu có quyền truy cập
  return null;
};

export default AccessibleRouteRedirect;
